// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"246":"6da52b536cf53c09f95f","809":"0acf822abd62f2b03f3f"}[chunkId] + ".js";
};